import React, { useState, useEffect } from 'react';
import { firestore } from '../../firebase/config';
import { collection, query, where, getDocs, doc, updateDoc } from 'firebase/firestore';
import '../../pages/Dashboard.css';
import './GerenciarSupervisores.css';
import { useLocalidades } from '../../hooks/useLocalidades';

function GerenciarSupervisores() {
    const [supervisores, setSupervisores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [editandoId, setEditandoId] = useState(null);
    const [localidadesSelecionadas, setLocalidadesSelecionadas] = useState([]);

    // Lista de localidades carregada dinamicamente do Firestore
    const { localidades: localidadesFirestore } = useLocalidades();
    const TODAS_LOCALIDADES = localidadesFirestore.map(l => l.nome);

    // Busca todos os supervisores cadastrados
    useEffect(() => {
        fetchSupervisores();
    }, []);

    const fetchSupervisores = async () => {
        setLoading(true);
        try {
            const q = query(collection(firestore, 'usuarios'), where('perfil', '==', 'supervisor'));
            const querySnapshot = await getDocs(q);
            const supervisoresData = querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data(),
                localidades: doc.data().localidades || []
            }));
            setSupervisores(supervisoresData);
        } catch (error) {
            console.error('Erro ao buscar supervisores:', error);
            alert('Erro ao carregar supervisores.');
        }
        setLoading(false);
    };

    const handleEditar = (supervisor) => {
        setEditandoId(supervisor.id);
        setLocalidadesSelecionadas(supervisor.localidades || []);
    };

    const handleCancelar = () => {
        setEditandoId(null);
        setLocalidadesSelecionadas([]);
    };

    const handleSalvar = async (supervisorId) => {
        setLoading(true);
        try {
            const supervisorRef = doc(firestore, 'usuarios', supervisorId);
            await updateDoc(supervisorRef, {
                localidades: localidadesSelecionadas
            });
            alert('Localidades atualizadas com sucesso!');
            setEditandoId(null);
            setLocalidadesSelecionadas([]);
            fetchSupervisores(); // Recarrega a lista
        } catch (error) {
            console.error('Erro ao atualizar supervisor:', error);
            alert('Erro ao salvar alterações.');
        }
        setLoading(false);
    };

    const toggleLocalidade = (localidade) => {
        if (localidadesSelecionadas.includes(localidade)) {
            setLocalidadesSelecionadas(localidadesSelecionadas.filter(l => l !== localidade));
        } else {
            setLocalidadesSelecionadas([...localidadesSelecionadas, localidade]);
        }
    };

    const selecionarTodas = () => {
        setLocalidadesSelecionadas([...TODAS_LOCALIDADES]);
    };

    const desmarcarTodas = () => {
        setLocalidadesSelecionadas([]);
    };

    return (
        <div className="gerenciar-supervisores">
            <h2>Gerenciar Supervisores</h2>
            <p style={{ marginBottom: '20px', color: '#666' }}>
                Atribua localidades aos supervisores. Cada supervisor verá apenas os dados das localidades atribuídas a ele.
            </p>

            {loading && <p>Carregando...</p>}

            {supervisores.length === 0 && !loading && (
                <p style={{ textAlign: 'center', color: '#999', marginTop: '40px' }}>
                    Nenhum supervisor cadastrado ainda.
                </p>
            )}

            <div className="supervisores-list">
                {supervisores.map(supervisor => (
                    <div key={supervisor.id} className="supervisor-card">
                        <div className="supervisor-header">
                            <div>
                                <h3>{supervisor.nome || 'Sem nome'}</h3>
                                <p style={{ color: '#666', fontSize: '0.9em' }}>{supervisor.email}</p>
                            </div>
                            {editandoId !== supervisor.id && (
                                <button
                                    onClick={() => handleEditar(supervisor)}
                                    className="btn-editar"
                                    disabled={loading}
                                >
                                    Editar Localidades
                                </button>
                            )}
                        </div>

                        {editandoId === supervisor.id ? (
                            <div className="localidades-editor">
                                <div style={{ marginBottom: '15px', display: 'flex', gap: '10px' }}>
                                    <button onClick={selecionarTodas} type="button" style={{ padding: '8px 15px', fontSize: '0.9em' }}>
                                        Selecionar Todas
                                    </button>
                                    <button onClick={desmarcarTodas} type="button" style={{ padding: '8px 15px', fontSize: '0.9em', backgroundColor: '#6c757d' }}>
                                        Desmarcar Todas
                                    </button>
                                    <span style={{ marginLeft: 'auto', alignSelf: 'center', color: '#666' }}>
                                        {localidadesSelecionadas.length} selecionada(s)
                                    </span>
                                </div>

                                <div className="localidades-grid">
                                    {TODAS_LOCALIDADES.map(localidade => (
                                        <label key={localidade} className="localidade-checkbox">
                                            <input
                                                type="checkbox"
                                                checked={localidadesSelecionadas.includes(localidade)}
                                                onChange={() => toggleLocalidade(localidade)}
                                            />
                                            {localidade}
                                        </label>
                                    ))}
                                </div>

                                <div className="editor-actions">
                                    <button onClick={handleCancelar} disabled={loading} className="btn-cancelar">
                                        Cancelar
                                    </button>
                                    <button onClick={() => handleSalvar(supervisor.id)} disabled={loading} className="btn-salvar">
                                        {loading ? 'Salvando...' : 'Salvar'}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div className="localidades-display">
                                {supervisor.localidades && supervisor.localidades.length > 0 ? (
                                    <div className="localidades-tags">
                                        {supervisor.localidades.map(loc => (
                                            <span key={loc} className="localidade-tag">{loc}</span>
                                        ))}
                                    </div>
                                ) : (
                                    <p style={{ color: '#999', fontStyle: 'italic' }}>Nenhuma localidade atribuída</p>
                                )}
                            </div>
                        )}
                    </div>
                ))}
            </div>


        </div>
    );
}

export default GerenciarSupervisores;
